import { render, staticRenderFns } from "./KVXiaomi12t.vue?vue&type=template&id=16f1c2b8&scoped=true&"
import script from "./KVXiaomi12t.vue?vue&type=script&lang=js&"
export * from "./KVXiaomi12t.vue?vue&type=script&lang=js&"
import style0 from "./KVXiaomi12t.vue?vue&type=style&index=0&id=16f1c2b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f1c2b8",
  null
  
)

export default component.exports